/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoanInsuranceConfigDto } from './LoanInsuranceConfigDto';
import {
    LoanInsuranceConfigDtoFromJSON,
    LoanInsuranceConfigDtoFromJSONTyped,
    LoanInsuranceConfigDtoToJSON,
    LoanInsuranceConfigDtoToJSONTyped,
} from './LoanInsuranceConfigDto';
import type { LoanBaseDto } from './LoanBaseDto';
import {
    LoanBaseDtoFromJSON,
    LoanBaseDtoFromJSONTyped,
    LoanBaseDtoToJSON,
    LoanBaseDtoToJSONTyped,
} from './LoanBaseDto';

/**
 * Loan configuration with associated insurance settings
 * @export
 * @interface LoanConfigurationDto
 */
export interface LoanConfigurationDto {
    /**
     * 
     * @type {LoanBaseDto}
     * @memberof LoanConfigurationDto
     */
    loan: LoanBaseDto;
    /**
     * 
     * @type {LoanInsuranceConfigDto}
     * @memberof LoanConfigurationDto
     */
    insuranceConfig: LoanInsuranceConfigDto;
}

/**
 * Check if a given object implements the LoanConfigurationDto interface.
 */
export function instanceOfLoanConfigurationDto(value: object): value is LoanConfigurationDto {
    if (!('loan' in value) || value['loan'] === undefined) return false;
    if (!('insuranceConfig' in value) || value['insuranceConfig'] === undefined) return false;
    return true;
}

export function LoanConfigurationDtoFromJSON(json: any): LoanConfigurationDto {
    return LoanConfigurationDtoFromJSONTyped(json, false);
}

export function LoanConfigurationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoanConfigurationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'loan': LoanBaseDtoFromJSON(json['loan']),
        'insuranceConfig': LoanInsuranceConfigDtoFromJSON(json['insuranceConfig']),
    };
}

export function LoanConfigurationDtoToJSON(json: any): LoanConfigurationDto {
    return LoanConfigurationDtoToJSONTyped(json, false);
}

export function LoanConfigurationDtoToJSONTyped(value?: LoanConfigurationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loan': LoanBaseDtoToJSON(value['loan']),
        'insuranceConfig': LoanInsuranceConfigDtoToJSON(value['insuranceConfig']),
    };
}

